import { useState } from 'react';
import { Container } from 'theme-ui';
import { Swiper, SwiperSlide } from 'swiper/react';

import { themed } from './Slider.theme';
import { useSliderParams } from './useSliderParams';
import { Tile } from '../Tile';

export const Slider = themed(({ theme, tiles }) => {
  const [swiper, setSwiper] = useState();
  const defaultParams = useSliderParams();

  return (
    <Container data-comp={Slider.displayName} sx={theme.swiper}>
      <Swiper onSwiper={setSwiper} {...defaultParams}>
        {tiles?.slice(0, 6).map((item, index) => {
          return (
            <SwiperSlide key={index + 1}>
              <Tile item={item} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Container>
  );
});

Slider.displayName = 'Slider';
